import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ImgSendBill_en from '../../../assets/modal/invoice_en.png';
import ImgSendBill_de from '../../../assets/modal/invoice_de.png';
import ImgReportLiablility_en from '../../../assets/modal/report_liability_en.png';
import ImgReportLiablility_de from '../../../assets/modal/report_liability_de.png';
import ImgAdditionalDoc_en from '../../../assets/modal/submit_additional_doc_en.png';
import ImgAdditionalDoc_de from '../../../assets/modal/submit_additional_doc_de.png';
import ImgCostEstimate_en from '../../../assets/modal/cost_estimate_en.png';
import ImgCostEstimate_de from '../../../assets/modal/cost_estimate_de.png';
import ImgDirectBilling_en from '../../../assets/modal/direct_billing_en.png';
import ImgDirectBilling_de from '../../../assets/modal/direct_billing_de.png';
import ArrowLeftSmall from '../../../assets/PetPage/arrow_left_dashed_small.svg';
import PandaHeadBothHands from '../../../assets/header/panda-logo-both-hands.svg';
import { isMobileOnly, isTablet } from 'react-device-detect';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import ModalExistingClaim from './ModalExistingClaim';
import ModalRequireChip from './ModalRequireChip';
import { useDispatch, useSelector } from 'react-redux';
import {
  setSelectedFlowTypeToSkip,
  updateClaimIDList,
  updateExistingType,
  updateFlowCurrentStep,
  updateInitialTableDetails,
  updateMissedChip,
  updateMissedDiag,
  updateTableDetails,
  updateTDProcessed,
  updateWtdModalOpen,
} from '../../../config/actions';
import { projectSettings } from '../../../config/setting';
import { getToken } from '../../../config/token';
import { Request } from '../../../config/requests';
import Loading from '../../../components/common/Loading';
import { showToast } from '../../../config/helpers';
import { TERMINATION_REASONS } from '../../../constants/ApplicationConstants';

function ModalWhatToDo({
  setOpenModalWhatToDo,
  setOpenModalPetSelect = null,
  petId,
}) {
  const token = getToken();
  const { t, i18n } = useTranslation();
  const router = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { id } = useParams();
  const pets = useSelector((s) => s.flow.pets);
  const currentPetInfo = useSelector((s) => s.flow.selectedPetInfo);
  const [isLoading, setIsLoading] = useState(false);
  const [reportType, setReportType] = useState(null);
  const [openModalExistingClaim, setOpenModalExistingClaim] = useState(false);
  const [openModalRequireChip, setOpenModalRequireChip] = useState(false);
  const [isAllFlowsAvailable, setIsAllFlowsAvailable] = useState(false);
  const isCreateClaimDisabled = currentPetInfo.policyTerminationType === 'full-rollback'
    || currentPetInfo.policyTerminationReason === TERMINATION_REASONS.WITHDRAWAL;

  const getAvailableFlows = async () => {
    setIsLoading(true);
    return Request({
      method: 'get',
      token: token,
      route: `api/claims/claims_exist/${petId}`,
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Request failed with status ${res.status}`);
        }
        return res.json();
      })
      .then((json) => {
        setIsAllFlowsAvailable(json.data);
      })
      .catch((error) => {
        console.error(error);
        showToast(t('somethingWentWrong'), { error: true });
        setOpenModalWhatToDo(false);
        router('/');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  function handleClose() {
    setOpenModalWhatToDo(false);
    dispatch(updateWtdModalOpen(false));
  }

  const resetFlowStateHandler = () => {
    dispatch(updateFlowCurrentStep(0));
    dispatch(updateTableDetails([]));
    dispatch(updateExistingType(''));
    dispatch(updateClaimIDList([]));
    dispatch(updateMissedChip(true));
    dispatch(updateMissedDiag(false));
    dispatch(updateTDProcessed(false));
    dispatch(updateInitialTableDetails([]));
  };

  useEffect(() => {
    if (currentPetInfo?.chipNumber && currentPetInfo.chipNumber.length === 15) {
      getAvailableFlows();
    } else {
      setOpenModalRequireChip(true);
    }
  }, []);

  return (
    <>
      <div className="modal-wtd FastShow">
        <div className="modal-wtd__background">
          {isLoading ? (
            <div className="modal-wtd__background__loader">
              <Loading noText fast />
            </div>
          ) : (
            <>
              <div
                className={`modal-wtd__button ${isMobileOnly ? 'mobile' : ''} ${isTablet ? 'tablet' : ''} no-pointer`}
              >
                <img src={PandaHeadBothHands} />
                <div
                  className={
                    isMobileOnly
                      ? 'button_red_mobile dark'
                      : 'button_red_common dark'
                  }
                >
                  {t('selectOption2')}
                </div>
              </div>

              <div
                className={`modal-wtd__${!isCreateClaimDisabled ? 'type' : 'type-disabled'} send_bill ${isMobileOnly ? 'mobile' : ''} ${isTablet ? 'tablet' : ''}`}
                onClick={() => {
                  if (!isCreateClaimDisabled) {
                    setReportType('General');
                    resetFlowStateHandler();
                    dispatch(setSelectedFlowTypeToSkip('General'));
                    if (projectSettings.existingClaim && isAllFlowsAvailable) {
                      setOpenModalExistingClaim(true);
                    } else {
                      router(
                        `/contact/${petId}/claim?type=${encodeURIComponent(
                          'General'
                        )}`
                      );
                      setOpenModalWhatToDo(false);
                      dispatch(updateWtdModalOpen(false));
                    }
                  }
                }}
              >
                <img src={i18n.language === 'en' ? ImgSendBill_en : ImgSendBill_de} />
              </div>

              <div
                className={`modal-wtd__type-disabled report_liab ${isMobileOnly ? 'mobile' : ''} ${isTablet ? 'tablet' : ''}`}
              // onClick={() => {
              //   setReportType("Liability claim");
              //   resetFlowStateHandler();
              //   dispatch(setSelectedFlowTypeToSkip("Liability claim"));
              //   if (projectSettings.existingClaim && isAllFlowsAvailable) {
              //     setOpenModalExistingClaim(true);
              //   } else {
              //     router(
              //       `/contact/${petId}/claim?type=${encodeURIComponent(
              //         "Liability claim"
              //       )}`
              //     );
              //     setOpenModalWhatToDo(false);
              //     dispatch(updateWtdModalOpen(false));
              //   }
              // }}
              >
                <img src={i18n.language === 'en' ? ImgReportLiablility_en : ImgReportLiablility_de} />
              </div>

              {projectSettings.existingClaim && (
                <div
                  className={`modal-wtd__${isAllFlowsAvailable && !isCreateClaimDisabled ? 'type' : 'type-disabled'} resend_docs ${isMobileOnly ? 'mobile' : ''} ${isTablet ? 'tablet' : ''}`}
                  onClick={() => {
                    if (isAllFlowsAvailable && !isCreateClaimDisabled) {
                      resetFlowStateHandler();
                      dispatch(setSelectedFlowTypeToSkip(''));
                      router(
                        `/contact/${petId}/claim?type=${encodeURIComponent(
                          'Existing Claim'
                        )}`
                      );
                      setOpenModalWhatToDo(false);
                      dispatch(updateWtdModalOpen(false));
                    }
                  }}
                >
                  <img src={i18n.language === 'en' ? ImgAdditionalDoc_en : ImgAdditionalDoc_de} />
                </div>
              )}

              <div
                className={`modal-wtd__${!isCreateClaimDisabled ? 'type' : 'type-disabled'} cost_calc ${isMobileOnly ? 'mobile' : ''} ${isTablet ? 'tablet' : ''}`}
                onClick={() => {
                  if (!isCreateClaimDisabled) {
                    setReportType('Cost estimation');
                    resetFlowStateHandler();
                    dispatch(setSelectedFlowTypeToSkip('Cost estimation'));
                    if (projectSettings.existingClaim && isAllFlowsAvailable) {
                      setOpenModalExistingClaim(true);
                    } else {
                      router(
                        `/contact/${petId}/claim?type=${encodeURIComponent(
                          'Cost estimation'
                        )}`
                      );
                      setOpenModalWhatToDo(false);
                      dispatch(updateWtdModalOpen(false));
                    }
                  }
                }}
              >
                <img src={i18n.language === 'en' ? ImgCostEstimate_en : ImgCostEstimate_de} />
              </div>

              <div
                className={`modal-wtd__${!isCreateClaimDisabled ? 'type' : 'type-disabled'} bill_dir ${isMobileOnly ? 'mobile' : ''} ${isTablet ? 'tablet' : ''}`}
                onClick={() => {
                  if (!isCreateClaimDisabled) {
                    setReportType('General to Vets');
                    resetFlowStateHandler();
                    dispatch(setSelectedFlowTypeToSkip('General to Vets'));
                    if (projectSettings.existingClaim && isAllFlowsAvailable) {
                      setOpenModalExistingClaim(true);
                    } else {
                      router(
                        `/contact/${petId}/claim?type=${encodeURIComponent(
                          'General to Vets'
                        )}`
                      );
                      setOpenModalWhatToDo(false);
                      dispatch(updateWtdModalOpen(false));
                    }
                  }
                }}
              >
                <img src={i18n.language === 'en' ? ImgDirectBilling_en : ImgDirectBilling_de} />
              </div>

              <div
                className={`modal-wtd__back_bar ${isMobileOnly ? 'mobile' : ''} ${isTablet ? 'tablet' : ''
                  }`}
                onClick={() => {
                  handleClose();
                  if (setOpenModalPetSelect) {
                    setOpenModalPetSelect(
                      pets.length === 1 || pathname === `/pet/${id}`
                        ? false
                        : true
                    );
                  }
                }}
              >
                <img src={ArrowLeftSmall} />
                <span>{t('back')}</span>
              </div>
            </>
          )}
        </div>
      </div>

      {openModalExistingClaim && (
        <ModalExistingClaim
          openModalExistingClaim={openModalExistingClaim}
          setOpenModalExistingClaim={setOpenModalExistingClaim}
          petId={petId}
          reportType={reportType}
          setOpenModalWhatToDo={setOpenModalWhatToDo}
        />
      )}
      {openModalRequireChip && (
        <ModalRequireChip
          openModalRequireChip={openModalRequireChip}
          setOpenModalRequireChip={setOpenModalRequireChip}
          petId={petId}
          setOpenModalWhatToDo={setOpenModalWhatToDo}
        />
      )}
    </>
  );
}

export default ModalWhatToDo;
